/**
    * @description      :
    * @author           :
    * @group            :
    * @created          : 20/07/2021 - 15:26:48
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 20/07/2021
    * - Author          :
    * - Modification    :
**/
import * as React from "react"

const UserVetor = (props) => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 9.563A4.782 4.782 0 008.5 0a4.782 4.782 0 000 9.563zm4.25 1.062h-1.83a5.786 5.786 0 01-4.84 0H4.25A4.25 4.25 0 000 14.875v.531C0 16.286.714 17 1.594 17h13.812c.88 0 1.594-.714 1.594-1.594v-.531a4.25 4.25 0 00-4.25-4.25z"
        fill="#24A95D"
      />
    </svg>
  )
}

export default React.memo(UserVetor)
